import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import {
  FormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { ParentButtonComponent } from '../../../../shared/components/ui/parent-button/parent-button.component';
import { InputFieldComponent } from '../../../../shared/components/ui/input-field/input-field.component';
import { ParentTotpEnrollment } from '../../services/step-up-password.service';

export type TotpEnrollDialogResult = { code: string };

@Component({
  selector: 'app-totp-enroll-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    TranslatePipe,
    ParentButtonComponent,
    InputFieldComponent,
  ],
  templateUrl: './totp-enroll-dialog.component.html',
  styleUrl: './totp-enroll-dialog.component.scss',
})
export class TotpEnrollDialogComponent {
  #dialogRef = inject(
    MatDialogRef<TotpEnrollDialogComponent, TotpEnrollDialogResult | null>,
  );
  #fb = inject(FormBuilder);
  readonly data = inject<ParentTotpEnrollment>(MAT_DIALOG_DATA);
  readonly copied = signal(false);

  readonly form = this.#fb.nonNullable.group({
    code: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
  });

  async copySecret(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.data.secret);
      this.copied.set(true);
    } catch {
      this.copied.set(false);
    }
  }

  cancel(): void {
    this.#dialogRef.close(null);
  }

  confirm(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.#dialogRef.close({ code: this.form.controls.code.value.trim() });
  }
}
